import { render, staticRenderFns } from "./commerce-list-table.vue?vue&type=template&id=3d746dcc"
import script from "./commerce-list-table.vue?vue&type=script&lang=js"
export * from "./commerce-list-table.vue?vue&type=script&lang=js"
import style0 from "./commerce-list-table.vue?vue&type=style&index=0&id=3d746dcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports